import SharepointUpload from '../components/psc/lib/SharepointUpload'

const RecordSharepointUpload = () => {
    return (
        <SharepointUpload
            entityType="Record"
            apiPath="records"
            statusField="record_status"
        />
    )
};

export default RecordSharepointUpload
